export default {
    _prefix: "FormViewerPreview",
    metadata: {
        labels: {
            formName: "Form Name:",
        },
    },
    labels: {
        previewSubmitEvaluation: "Preview Submit Evaluation",
        previewSubmitAssessment: "Preview Submit Assessment",
        previewSubmitSurvey: "Preview Submit Survey",
        rescore: "Re-Score",
        reviseScore: "Revise Score",
        save: "Save",
        signOff: "Sign Off",
        cancel: "Cancel",
    },
};
